import * as RadixTabs from '@radix-ui/react-tabs';
import type { ReactNode } from 'react';
import { cx } from '../../utils/cx';
import s from './Tabs.module.css';

export type TabItem = { value: string; label: ReactNode; leading?: ReactNode; disabled?: boolean };

export type TabsProps = {
  value: string;
  onValueChange: (value: string) => void;
  items: TabItem[];
  /** Accessible name for the tab list, e.g. "Recipients". */
  label: string;
  variant?: 'underline' | 'pill';
  children: ReactNode;
  className?: string;
};

/** Tabs that scroll horizontally with snap on phones (e.g. recipient tabs with avatars). */
export function Tabs({
  value,
  onValueChange,
  items,
  label,
  variant = 'underline',
  children,
  className,
}: TabsProps) {
  return (
    <RadixTabs.Root value={value} onValueChange={onValueChange} className={cx(s.root, className)}>
      <RadixTabs.List className={s.list} data-variant={variant} aria-label={label}>
        {items.map((t) => (
          <RadixTabs.Trigger key={t.value} value={t.value} disabled={t.disabled} className={s.tab}>
            {t.leading ? (
              <span className={s.leading} aria-hidden="true">
                {t.leading}
              </span>
            ) : null}
            {t.label}
          </RadixTabs.Trigger>
        ))}
      </RadixTabs.List>
      {children}
    </RadixTabs.Root>
  );
}

export function TabPanel({
  value,
  children,
  className,
}: {
  value: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <RadixTabs.Content value={value} className={cx(s.panel, className)}>
      {children}
    </RadixTabs.Content>
  );
}
